export default "__VITE_ASSET__CDCWwsnA__"